// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 17px 20px;
  margin: 0;
  border-radius: 16px;
  background: #F6F1EF;
}
.container .cross {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 25px;
  height: 25px;
  z-index: 99;
  margin: 0px;
  background: var(--color-white-accent);
  min-width: 25px;
  min-height: 25px;
  max-width: 25px;
  max-height: 25px;
  padding: 0px;
  z-index: 99;
}
.container .cross ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.container .cross:hover {
  background: #f2dbd9;
}

.title {
  font-family: AppFontMedium, sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  margin-bottom: 8px;
  text-transform: uppercase;
}

.info {
  font-family: AppFontLight;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--color-black);
  margin-bottom: 55px;
  text-transform: uppercase;
}

.button {
  height: 25px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}
.button:last-child {
  margin-bottom: 0;
}
.button:hover {
  background: #f2dbd9;
}
.button_main {
  background: var(--not-active-btn);
  font-family: AppFont, sans-serif;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  border-radius: 26px;
  text-transform: uppercase;
}
.button_main:hover {
  --background: #f2dbd9 !important;
}
.button_close {
  background: transparent;
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  border: 1px solid var(--ion-color-primary);
  border-radius: 26px;
  color: var(--color-black);
  border: 1px solid var(--color-black);
}`, "",{"version":3,"sources":["webpack://./src/app/components/show-on-map-venue-dialog/show-on-map-venue-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AACN;AAAM;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAEV;AAAM;EACI,mBAAA;AAEV;;AAGE;EACE,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;;AAGE;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;;AAIE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AADJ;AAEI;EACE,gBAAA;AAAN;AAGI;EACE,mBAAA;AADN;AAII;EACE,iCAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAFN;AAGM;EACE,gCAAA;AADR;AAMI;EACE,uBAAA;EACA,yBAAA;EAEA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;AALN","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 17px 20px;\n    margin: 0;\n    border-radius: 16px;\n    background: #F6F1EF;\n\n    .cross {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      width: 25px;\n      height: 25px;\n      z-index: 99;\n      margin: 0px;\n      background: var(--color-white-accent);\n      min-width: 25px;\n      min-height: 25px;\n      max-width: 25px;\n      max-height: 25px;\n      padding: 0px;\n      z-index: 99;\n      ion-icon {\n          width: 100%;\n          height: 100%;\n          margin: 0px;\n      }\n      &:hover {\n          background: #f2dbd9;\n      }\n    }\n  }\n  \n  .title {\n    font-family: AppFontMedium, sans-serif;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.06em;\n    text-align: center;\n    color: var(--color-black);\n    margin-bottom: 8px;\n    text-transform: uppercase;\n  }\n  \n  .info {\n    font-family: AppFontLight;\n    font-size: 13px;\n    line-height: 15px;\n    letter-spacing: 0.02em;\n    text-align: center;\n    color: var(--color-black);\n    margin-bottom: 55px;\n    text-transform: uppercase;\n  \n  }\n  \n  .button {\n    height: 25px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n    cursor: pointer;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  \n    &:hover {\n      background: #f2dbd9;\n\n    }\n    &_main {\n      background: var(--not-active-btn);\n      font-family: AppFont, sans-serif;\n      font-size: 12px;\n      line-height: 15px;\n      letter-spacing: 0.06em;\n      text-align: center;\n      color: var(--color-black);\n      border-radius: 26px;\n      text-transform: uppercase;\n      &:hover {\n        --background: #f2dbd9 !important;\n      }\n  \n    }\n  \n    &_close {\n      background: transparent;\n      text-transform: uppercase;\n  \n      font-family: AppFont, sans-serif;\n      font-size: 15px;\n      line-height: 25px;\n      letter-spacing: 0.06em;\n      text-align: center;\n      border: 1px solid var(--ion-color-primary);\n      border-radius: 26px;\n      color: var(--color-black);\n      border: 1px solid var(--color-black);\n  \n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
